import React, { FC } from 'react';

export interface ButtonIconProps {
  imgSrc: string;
  uniqueKey: string;
  style?: React.CSSProperties;
}

const ButtonIcon: FC<ButtonIconProps> = ({ imgSrc, uniqueKey, style }) => {
  return (
    <img
      style={style}
      src={imgSrc}
      className={`partner-service-button__img--${uniqueKey}`}
      alt={uniqueKey}
    />
  );
};

export default ButtonIcon;
